import { useEffect, useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import { useTranslation } from 'react-i18next';

import i18n from '@/i18n';

type LanguageOption = {
    code: string;
    label: string;
};

const LANGS: LanguageOption[] = [
    { code: 'en', label: 'English' },
    { code: 'zh-Hant', label: '繁體中文' },
    { code: 'ja', label: '日本語' },
    { code: 'fr', label: 'Français' },
    { code: 'es', label: 'Español' },
    { code: 'de', label: 'Deutsch' },
    { code: 'ko', label: '한국어' },
    { code: 'ar', label: 'العربية' },
];

export default function LanguageSwitcherIcon() {
    const { t } = useTranslation('common');
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const current = i18n.resolvedLanguage || 'en';

    useEffect(() => {
        document.documentElement.lang = current;
        document.documentElement.dir = current === 'ar' ? 'rtl' : 'ltr';
    }, [current]);

    return (
        <>
            <Tooltip title={t('Language')}>
                <IconButton
                    size="small"
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    sx={{ border: '1px solid var(--mui-palette-divider)', ml: 0.5 }}
                    aria-label={t('Language')}
                >
                    <PublicIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Menu
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {LANGS.map((l) => (
                    <MenuItem
                        key={l.code}
                        selected={l.code === current}
                        onClick={() => {
                            i18n.changeLanguage(l.code);
                            setAnchorEl(null);
                        }}
                    >
                        {l.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
